import React, { useState, useEffect } from "react";
import Group from "./Group";
import styles from "assets/scss/task_management.module.css";
import "assets/scss/style.css";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import { PayrollClient } from "services";
import { useOrganisationContext, useUserContext } from "hooks";
import { Page } from 'components/common';
import BackButton from 'components/refactoring/BackButton';
import { NotificationManager } from "react-notifications";
import AddGroup from "./AddGroup";

const Groups = ({ t, match }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [employees, setEmployees] = useState([]);
    const [groups, setGroups] = useState([]);
    const [showGroupModal, setShowGroupModal] = useState(false);

    const client = PayrollClient();
    const { selectedOrganisation } = useOrganisationContext();
    const { user } = useUserContext();

    const userPermission = user?.permissions?.includes("hr_task_manager");

    useEffect(() => {
          fetchGroups();
          fetchEmployees();
  }, [selectedOrganisation]);

    const fetchEmployees = async () => {
      try {
          const response = await client.get(`/employees-list-for-task`);
          const data = response.data;
          setEmployees(data);
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  };

  const filteredGroups = groups?.filter(group =>
      (group?.group_name?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

    const fetchGroups = async () => {
          try {
              const response = await client.get(`/group-employees-management/list-of-groups`);
              const data = response;
              setGroups(data.data);
          } catch (error) {
              console.error("Error fetching groups:", error);
          }
      };

    const handleSaveGroup = async (group) => {
      try {
          await client.post(`/group-employees-management`, group);
          fetchGroups();
          NotificationManager.success(t("Group added successfully"));
      } catch (error) {
          console.error('Error adding group:', error);
          NotificationManager.error(t("Failed to add group"));
      }
    };

    const handleDeleteGroup = async (group) => {
      try {
          await client.delete(`/group-employees-management/${group.id}`);
          fetchGroups();
          NotificationManager.success(t("Group deleted successfully"));
      } catch (error) {
          console.error('Error deleting group:', error);
          NotificationManager.error(t("Failed to delete group"));
      }
    };

    const handleUpdateGroup = async (group) => {
      try {
          await client.put(`/group-employees-management/${group.id}/update-group`, group);
          fetchGroups();
          NotificationManager.success(t("Group updated successfully"));
      } catch (error) {
          console.error('Error updating group:', error);
          NotificationManager.error(t("Failed to Update group"));
      }
    };

    return (

        
        <Page title={t("Groups")}>
          <BackButton/>
          <div className={styles.groupContainer}>
          <div className={styles.groupHeader}>
                <input 
                    className={styles.searchBar}
                    type="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={t("Search groups...")}
                />
                <button className={styles.addButton} onClick={() => setShowGroupModal(true)}>+ <Trans>Add New Group</Trans></button>
            </div>
        <Table size="sm" className="small" style={{border: '1px solid #e9ecef'}}>
          <thead>
            <tr>
              <th className="text-left"><Trans>Group Name</Trans></th>
              <th className="text-left"><Trans># of Employees</Trans></th>
              <th className="text-center"><Trans>Action</Trans></th>
              <th className="text-right" />
            </tr>
          </thead>
          {filteredGroups ? filteredGroups?.map((group, index) => (
              <Group
                key={index}
                group={group}
                onUpdateGroup={handleUpdateGroup}
                handleDeleteGroup={handleDeleteGroup}
                employees={employees}
                selectedOrganisation={selectedOrganisation}
                t={t}
            />
            )):
              groups?.map((group, index) => (
                <Group
                    key={index}
                    group={group}
                    onUpdateGroup={handleUpdateGroup}
                    handleDeleteGroup={handleDeleteGroup}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                    t={t}
                />
            ))
          }
        </Table>
        </div>
        {userPermission && (
                <AddGroup
                    isOpen={showGroupModal}
                    onClose={() => setShowGroupModal(false)}
                    onSave={handleSaveGroup}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                    t={t}
                />
            )}
        </Page>
    );
};

export default Groups;